import React from 'react';
import { Box } from '@chakra-ui/react';

import { useConversation } from '../../../redux/hooks/answer/conversation-hooks';
import { useConversationsContext } from '../ConversationsContext';
import { ChatInput } from '../Input/ChatInput';
import { ChatLoader } from '../Loader/ChatLoader';
import { ChatBottomScroller } from '../Message/ChatBottomScroller';

import { AgentWarning } from './AgentWarning';
import { MessageListHeader } from './MessageListHeader';
import { MessagesInfiniteScrollLoader } from './MessagesInfiniteScrollLoader';
import { MessagesRenderer } from './MessagesRenderer';

import styles from './MessageList.module.scss';

export type MessageListProps = {
    activeConversationId: string;
};

export const Messages: React.FC<MessageListProps> = ({ activeConversationId }) => {
    const { isLoading, conversation } = useConversation(activeConversationId);
    const { clearChat } = useConversationsContext();

    return (
        <Box className={styles.chat}>
            <MessageListHeader
                conversation={conversation}
                className={styles.header}
                conversationIsEmpty={conversation?.messages?.length === 0}
            />
            <ChatLoader isLoading={!conversation || isLoading}>
                <MessagesInfiniteScrollLoader className={styles.messages}>
                    <MessagesRenderer conversation={conversation} />
                    <ChatBottomScroller conversation={conversation} />
                </MessagesInfiniteScrollLoader>
            </ChatLoader>
            <Box className={styles.inputWrapper}>
                <AgentWarning conversation={conversation} onOpenNewChat={clearChat} />
                <ChatInput conversation={conversation} />
            </Box>
        </Box>
    );
};
